import axios from "axios";
import { BASE_URL, PORT } from "../../utils/constants/httpConstants";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = BASE_URL+PORT

export default axios;
